import { render, staticRenderFns } from "./buildingSelectBox.vue?vue&type=template&id=05b87654&scoped=true&"
import script from "./buildingSelectBox.vue?vue&type=script&lang=js&"
export * from "./buildingSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b87654",
  null
  
)

export default component.exports